import React from 'react';
import ReactPlayer from 'react-player';
import c from 'classnames';

import { Container, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import {
  PARAGRAPH_VIEW_MODE_DEFAULT,
  PARAGRAPH_VIEW_MODE_FULLSCREEN,
} from '../../../config/constants';

import './style.scss';

const ParagraphVideo = ({ entity, viewMode = PARAGRAPH_VIEW_MODE_DEFAULT }) => {
  const videoSource = entity.getIn(['field_media_item', 0, 'embed'], '');
  const controls = entity.getIn(['field_controls', 0, 'value'], '');
  const poster = entity.getIn(['field_poster', 0, 'value'], '');
  const autoplay = entity.getIn(['field_autoplay', 0, 'value'], '');
  const loop = entity.getIn(['field_loop', 0, 'value'], '');
  const caption = entity.getIn(['field_text', 0, 'processed']);

  const viewModeIsFullscreen = viewMode === PARAGRAPH_VIEW_MODE_FULLSCREEN;
  const paragraphClassNames = c('ParagraphVideo', { 'FullscreenVideo': viewModeIsFullscreen });

  const colClassNames = c('', {
    'col-12 col-md-8 offset-md-2': !viewModeIsFullscreen,
    'col-12': viewModeIsFullscreen,
  });

  const renderVideo = () => {
    return (
      <div className="row">
        <div className={colClassNames}>
          {videoSource && (
            <>
              <ReactPlayer
                url={videoSource}
                width="100%"
                controls={controls}
                playing={autoplay}
                loop={loop}
                light={poster}
                className="ParagraphVideo__video"
                playIcon={<span className="ParagraphVideo__video__poster icon icon-play icon-variant-2" />}
              />
              {caption && <WysiwygField className="ParagraphVideo__caption" html={caption} />}
            </>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className={paragraphClassNames}>
      {!viewModeIsFullscreen ? (
        <Container large>
          {renderVideo()}
        </Container>
      ) : (
        <>
          {renderVideo()}
        </>
      )}
    </div>
  );
};

export default ParagraphVideo;
